import React from 'react';

import { Box } from '@rover/kibble/core';

export interface ContainerProps {
  children: React.ReactNode;
}

const Container: React.FC<ContainerProps> = ({ children }) => {
  return (
    <Box maxHeight="450px" paddingX="1x" sx={{ overflowY: 'auto' }}>
      {children}
    </Box>
  );
};

export default Container;
